import { createApiAsyncThunk } from '@/services/apiService'

const MACRO_PROCESS_URL = 'macro_processes'
const PROCESS_TEMPLATES_URL = 'process_templates'

export const fetchTemplatesForEdit = createApiAsyncThunk(
  'macroProcessEdit/fetchTemplates',
  async (purpose, { api, rejectWithValue }) => {
    try {
      const response = await api
        .url(PROCESS_TEMPLATES_URL)
        .query({ purpose })
        .get()
      return response
    } catch (error) {
      return rejectWithValue(error.message || 'Erreur lors du chargement des templates')
    }
  }
)

export const addContainersToMacroProcess = createApiAsyncThunk(
  'macroProcessEdit/addContainers',
  async ({ macroProcessId, templatePositions }, { api, rejectWithValue }) => {
    try {
      const response = await api
        .url(`${MACRO_PROCESS_URL}/${macroProcessId}/add_containers`)
        .post({
          macro_process: {
            template_positions: templatePositions,
          },
        })
      return response
    } catch (error) {
      return rejectWithValue(error.data || { message: error.message, errors: {} })
    }
  }
)
